import { z } from 'zod';

export const CREATE_FLOW_BADGE_LABEL = 'Page draft';

export const QUICK_STARTS = [
  {
    label: 'Quote request',
    text: 'Create a page from this offer. Visitors should understand the value quickly, trust the proof, and request a quote without needing to call us first.',
  },
  {
    label: 'Service page',
    text: 'Create a page for our new service. Audience: small teams. Offer: 10-minute setup. Goal: collect qualified demo requests.',
  },
  {
    label: 'B2B demo page',
    text: 'Create a demo-request page for enterprise analytics buyers. Audience: VP and director-level operators. Lead with ROI, case-study proof, integration confidence, and a clean sales handoff.',
  },
  {
    label: 'Product page',
    text: 'Create a page for a new mobile fitness app. Audience: active adults 20-35. Show the habit, app proof, objections, and a clear download path.',
  },
  {
    label: 'Page cleanup',
    text: '"Our current page feels unfocused. Keep the brand, but tighten the promise, proof, and next action so the team can publish it with confidence."',
  },
];

export const briefSchema = z
  .string()
  .min(20, { message: 'Brief content must be at least 20 characters' })
  .max(600, { message: 'Brief content cannot exceed 600 characters' });
